import React, { Component, Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeaderBack from '../components/HeaderBack';
import ProfileResetPassword from '../../common/forms/ProfileResetPassword';
import ProfileChangePhoneNumber from '../../common/forms/ProfileChangePhoneNumber';
// import { Panel, PanelGroup } from 'react-bootstrap';
import isWindow from 'components/common/helpers/isWindow';
import TransHelper from 'components/common/translations/TransHelper';
import { Accordion } from 'react-bootstrap';

class MobileView extends Component {

  constructor(props) {
    super(props)
    this.locale = props.locale;
  }

  state = {
    width: isWindow ? window.innerWidth : 900,
    activeKey: null
  }

  // componentDidMount() {
  //   window.addEventListener('resize', this.handleWindowSizeChange);
  // }

  // componentWillUnmount() {
  //   window.removeEventListener('resize', this.handleWindowSizeChange);
  // }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  }

  handleSelect = (activeKey) => {
    this.setState({ activeKey });
  }

  trans = (key) => {
    return TransHelper.translate(this.locale, "content.form." + key);
  }

  render() {
    const { width } = this.state;

    return (
      <div className="content">
        <div className="content__desc">
          <HeaderBack locale={this.props.locale} />
          <h1>{this.trans('changePhoneAndPassword')}</h1>
          <div className="list-accordion list-accordion--arrows">
            <Accordion
              activeKey={activeKey}
              onSelect={setActiveKey}           // newKey => setActiveKey(newKey)
              id="accordion-payments"
            >
              {/* === ZMIANA NUMERU TELEFONU === */}
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <span className="heading-icon">
                    <FontAwesomeIcon icon={['fas', 'mobile-alt']} size="lg" />
                    {trans('changePhoneNumber')}
                    <FontAwesomeIcon icon={['fas', 'angle-up']} size="lg" />
                  </span>
                </Accordion.Header>

                <Accordion.Body>
                  <ProfileChangePhoneNumber locale={locale} />
                </Accordion.Body>
              </Accordion.Item>

              {/* === ZMIANA HASŁA === */}
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <span className="heading-icon">
                    <FontAwesomeIcon icon={['fas', 'lock']} size="lg" />
                    {trans('changePassword')}
                    <FontAwesomeIcon icon={['fas', 'angle-up']} size="lg" />
                  </span>
                </Accordion.Header>

                <Accordion.Body>
                  <ProfileResetPassword locale={locale} />
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
    );
  }
}

export default MobileView;